import React from 'react';
import Text from '../text-component/Text';
import { useNavigate } from "react-router-dom";
import Button from "../button-component/Button";
import { getStaticText } from '../../lables/lablesService';

/**
 * No match page component
 * 
 * @returns JSX
 */
const NoMatch = () => {
    //Navigate variable
    const navigate = useNavigate();

    /**
     * Method return to the parent page
     * 
     * @returns function 
     */
    const goBack = () => {
        return navigate("/")
    }

    return (
        <>
            <div onClick={goBack} className='text-center m-3 mt-5'>
                <Button
                    bgcolor={"warning"}
                    label={getStaticText('go_home_btn')}
                    btn_styles={"p-1 pt-0 pb-0 text-white"}
                />
            </div>
            <div className='alert alert-danger m-5 text-center'>
                <Text content={getStaticText('not_found_msg')} />
            </div>
        </>

    )
}

export default NoMatch;
